import { FlagTypes } from '@generated/graphql';
import { severityFilterAccentColor } from '@ovComponents/4-module/reconFlags/utils/reconFlags.config';
import type { ReconFlagSeverity } from '@ovComponents/4-module/reconFlags/utils/reconFlags.types';

import type { Theme } from 'hephaestus/core';
/** Legacy / superseded flag types omitted from the glossary. */
export const FLAG_GLOSSARY_EXCLUDED_FLAG_TYPES = new Set<string>([
  FlagTypes.ProductSymbolDifferent,
  FlagTypes.MappingFileHoldings,
  FlagTypes.MappingActualHoldings,
  FlagTypes.PublishingDiffHoldings,
  FlagTypes.ExternalTransferInKind,
  FlagTypes.MoneyAvailableValueIncorrect,
  FlagTypes.DifferentHoldings,
]);

export const isFlagGlossaryEntryVisible = (flagType: string): boolean =>
  !FLAG_GLOSSARY_EXCLUDED_FLAG_TYPES.has(flagType);

export const FLAG_GLOSSARY_PAGE_SIZE = 15;

export type FlagGlossarySeverityFilterPillValue = 'ALL' | ReconFlagSeverity;

export const FLAG_GLOSSARY_SEVERITY_FILTER_PILLS: readonly {
  value: FlagGlossarySeverityFilterPillValue;
  labelKey: string;
}[] = [
  { value: 'ALL', labelKey: 'reconFlags.severity.all' },
  { value: 'CRITICAL', labelKey: 'reconFlags.severity.critical' },
  { value: 'HIGH', labelKey: 'reconFlags.severity.high' },
  { value: 'MEDIUM', labelKey: 'reconFlags.severity.medium' },
  { value: 'LOW', labelKey: 'reconFlags.severity.low' },
];

export const getFlagGlossarySeverityPillInactiveColor = (
  theme: Theme,
  value: FlagGlossarySeverityFilterPillValue,
): string =>
  value === 'ALL'
    ? String(theme.color.outline)
    : severityFilterAccentColor(theme, value);
